export const ensurePdfExtension = (url?: string): string => {
  if (!url) return '';
  return url.endsWith('.pdf') ? url : `${url}.pdf`;
};
